import { render, staticRenderFns } from "./SchedulePickupsTable.vue?vue&type=template&id=28002aa5&scoped=true&"
import script from "./SchedulePickupsTable.vue?vue&type=script&lang=js&"
export * from "./SchedulePickupsTable.vue?vue&type=script&lang=js&"
import style0 from "./SchedulePickupsTable.vue?vue&type=style&index=0&id=28002aa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28002aa5",
  null
  
)

export default component.exports